// Modül 1 - Ünite 3, 4, 5, 6 İçerikleri
// Kabin Memurluğuna Giriş - Günlük Hayat, Kariyer, Zorluklar, Final

const cabinCrewContentsM1U3to6 = {
  // ==================== ÜNİTE 3: GÜNLÜK HAYAT ====================
  'CM-M1-U3-L1': {
    lesson_id: 'CM-M1-U3-L1',
    title: 'Bir Günün Anatomisi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Memurunun Tipik Bir Günü',
      paragraphs: [
        'Kabin memurunun günü uçuştan saatler önce başlar. "Show time" denilen toplantı saatinde tüm ekip bir araya gelir.',
        'Briefing\'de uçuş detayları, özel yolcular, hava durumu, güvenlik uyarıları ve ekip görevleri paylaşılır.',
        'Uçak kontrolü: Kabin ekibi acil ekipmanları, koltukları, tuvaletleri ve mutfakları kontrol eder.',
        'Uçuş sırasında: Güvenlik demosu, yemek servisi, duty-free satışı, yolcu talepleri ve kabin düzeni.',
        'İniş sonrası: Kabin kontrolü, yolcu çıkışı, rapor yazımı ve bazen hızlı dönüş için yeni uçuşa hazırlık.'
      ],
      keyPoints: [
        'Show time uçuştan 1-2 saat önce başlar',
        'Briefing\'ler kritik önem taşır',
        'Her uçuş öncesi güvenlik kontrolü yapılır',
        'Gün uzun ve yorucu olabilir'
      ]
    }
  },

  'CM-M1-U3-L2': {
    lesson_id: 'CM-M1-U3-L2',
    title: 'Çalışma Saatleri ve Rotasyon',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Ekibi Çalışma Düzeni',
      paragraphs: [
        'Kabin memurları geleneksel 9-5 mesaisine sahip değildir. Vardiyalı sistem ve uçuş programları esastır.',
        'Duty time (görev süresi) yasal olarak sınırlıdır. SHGM ve EASA kuralları maksimum çalışma saatlerini belirler.',
        'Rotasyon sistemi: Kısa mesafe (short-haul) ekipleri günde birden fazla uçuş yapabilir. Uzun mesafe (long-haul) ekipleri tek uçuş yapar ama layover\'da kalır.',
        'Reserve (yedek) görevleri: Bazı günler evde veya havaalanında beklersiniz ve çağrıldığınızda uçuşa gidersiniz.',
        'Off day (izin günleri): Yoğun çalışma dönemlerinden sonra dinlenme günleri verilir.'
      ],
      keyPoints: [
        'Vardiyalı sistem - gece, gündüz, hafta sonu çalışma',
        'Duty time yasal olarak sınırlı',
        'Reserve görevleri olabilir',
        'Off day\'ler dinlenme için kritik'
      ]
    }
  },

  'CM-M1-U3-L3': {
    lesson_id: 'CM-M1-U3-L3',
    title: 'Layover Hayatı',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Yurtdışı Konaklama ve Deneyimler',
      paragraphs: [
        'Layover, uzun mesafe uçuşlarından sonra varış noktasında geçirilen süredir. Genellikle 1-3 gün arası.',
        'Havayolu şirketi otel, transfer ve per diem (günlük harcırah) sağlar.',
        'Layover\'lar şehir keşfi için fırsat sunar: New York, Dubai, Tokyo, Paris... Dünyanın en güzel şehirlerini görebilirsiniz.',
        'Dikkat: Layover eğlence değil, dinlenme zamanıdır. Jet lag ile mücadele ederken bir sonraki uçuşa hazır olmalısınız.',
        'Profesyonel yaklaşım: Alkol tüketimi, uyku düzeni ve fiziksel aktivite dengelenmelidir.'
      ],
      keyPoints: [
        'Layover = Varış noktasında kalış süresi',
        'Otel ve per diem havayolu tarafından karşılanır',
        'Şehir keşfi fırsatı ama dinlenme öncelikli',
        'Jet lag yönetimi önemli'
      ]
    }
  },

  'CM-M1-U3-L4': {
    lesson_id: 'CM-M1-U3-L4',
    title: 'Senaryo: Tipik Bir Hafta',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Bir kabin memuru adayı olarak mülakatta size soruyorlar:',
      question: '"Kabin memurluğunun zorlukları hakkında ne düşünüyorsunuz? Düzensiz çalışma saatleri sizi nasıl etkiler?"',
      options: [
        { id: 'A', text: 'Düzensiz saatler beni hiç etkilemez, her duruma adapte olurum.', isCorrect: false },
        { id: 'B', text: 'Dürüst olmak gerekirse, düzenli bir hayat tercih ederim ama bu meslek için vazgeçebilirim.', isCorrect: false },
        { id: 'C', text: 'Düzensiz saatlerin zorluğunu biliyorum. Uyku düzenimi yönetmek için stratejiler geliştirdim ve bu esnekliği bir avantaj olarak görüyorum.', isCorrect: true },
        { id: 'D', text: 'Jet lag ve uzun saatler endişelendirici ama denemeye değer.', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Zorlukları kabul edip çözüm odaklı yaklaşım gösterdiniz. Bu olgunluk mülakatçıları etkiler.',
        wrong: 'Bu cevap ya gerçekçi değil ya da endişe içeriyor. Zorluğu kabul edip çözüm sunmak en iyi strateji.'
      },
      explanation: 'Mülakatlarda zorlukları reddetmek veya aşırı endişeli görünmek olumsuz izlenim bırakır. En iyi strateji: 1) Zorluğu kabul et, 2) Hazırlıklı olduğunu göster, 3) Pozitif perspektif sun.'
    }
  },

  'CM-M1-U3-L5': {
    lesson_id: 'CM-M1-U3-L5',
    title: '🎮 Günlük Rutin Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { left: 'Show time', right: 'Ekip toplantısı saati' },
        { left: 'Briefing', right: 'Uçuş öncesi bilgilendirme' },
        { left: 'Duty time', right: 'Yasal çalışma süresi' },
        { left: 'Layover', right: 'Varış noktasında kalış' },
        { left: 'Reserve', right: 'Yedek görev bekleme' },
        { left: 'Per diem', right: 'Günlük harcırah' }
      ]
    }
  },

  // ==================== ÜNİTE 4: KARİYER YOLCULUĞU ====================
  'CM-M1-U4-L1': {
    lesson_id: 'CM-M1-U4-L1',
    title: 'Kariyer Basamakları',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Memurluğunda Kariyer İlerlemesi',
      paragraphs: [
        'Kabin memurluğu düz bir çizgi değil, basamaklı bir kariyer yoludur.',
        'Junior Cabin Crew: İlk 1-2 yıl. Temel görevler, öğrenme dönemi, kıdemli ekiple çalışma.',
        'Senior Cabin Crew: 3-5 yıl sonra. Daha fazla sorumluluk, özel yolcu servisi, junior ekibe mentorluk.',
        'Purser (Kabin Amiri): Kabin ekibinin lideri. Tüm kabin operasyonlarından sorumlu, pilot ile koordinasyon.',
        'Ötesi: Eğitmen, check kabin memuru, yer hizmetleri yöneticisi, havayolu yönetimi pozisyonları.'
      ],
      keyPoints: [
        'Junior → Senior → Purser → Yönetim',
        'Her basamak yeni sorumluluklar getirir',
        'Kıdem ve performans önemli',
        'Farklı kariyer dalları mümkün'
      ]
    }
  },

  'CM-M1-U4-L2': {
    lesson_id: 'CM-M1-U4-L2',
    title: 'Farklı Havayolu Türleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Havayolu Şirketlerinin Türleri',
      paragraphs: [
        'Network (Bayrak) Taşıyıcılar: THY, Lufthansa, Emirates gibi büyük şirketler. Geniş ağ, premium servis, yüksek standartlar.',
        'Low-Cost (Düşük Maliyetli): Pegasus, Ryanair, easyJet. Daha hızlı tempo, daha az frill, maliyet odaklı.',
        'Bölgesel Taşıyıcılar: AnadoluJet, SunExpress. Belirli bölgelere odaklı, genellikle daha kısa uçuşlar.',
        'Charter ve Özel: Tatil uçuşları, VIP jetler. Farklı deneyimler, özel müşteri kitlesi.',
        'Körfez Şirketleri: Emirates, Qatar, Etihad. Lüks servis, uluslararası ekip, yüksek maaş ama uzun saatler.'
      ],
      keyPoints: [
        'Her havayolu türünün avantaj ve dezavantajları var',
        'Kariyer hedeflerinize uygun olanı seçin',
        'Deneyim kazandıkça şirket değiştirebilirsiniz',
        'Her şirketin kültürü farklıdır'
      ]
    }
  },

  'CM-M1-U4-L3': {
    lesson_id: 'CM-M1-U4-L3',
    title: 'Maaş ve Yan Haklar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Memuru Ücret ve Hakları',
      paragraphs: [
        'Maaş yapısı: Temel maaş + uçuş başı ödeme + layover harcırahı + performans primi.',
        'Türkiye\'de ortalama: Başlangıç 25-35K TL, deneyimli 40-60K TL, Purser 60-80K TL (2024 verileri, değişkenlik gösterir).',
        'Körfez şirketleri: 3000-6000 USD arası net maaş + konaklama + ulaşım + sağlık sigortası.',
        'Yan haklar: Ücretsiz/indirimli uçuş bileti (staff travel), sağlık sigortası, emeklilik planı, eğitim olanakları.',
        'Dikkat: Maaşlar havayoluna, deneyime ve pozisyona göre büyük farklılık gösterir. Araştırma yapın!'
      ],
      keyPoints: [
        'Maaş = Temel + Uçuş + Harcırah + Prim',
        'Körfez şirketleri genellikle daha yüksek ödeme',
        'Staff travel önemli bir avantaj',
        'Deneyim ve kıdem maaşı artırır'
      ]
    }
  },

  'CM-M1-U4-L4': {
    lesson_id: 'CM-M1-U4-L4',
    title: '⚡ Kariyer Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Kabin ekibinin lideri kimdir?', options: ['Junior', 'Senior', 'Purser', 'Pilot'], correct: 2 },
        { q: 'THY hangi havayolu türüne girer?', options: ['Low-cost', 'Charter', 'Network/Bayrak', 'Bölgesel'], correct: 2 },
        { q: 'Staff travel ne demektir?', options: ['Çalışan uçuş bileti', 'Ek mesai', 'Layover', 'Reserve görevi'], correct: 0 },
        { q: 'Per diem nedir?', options: ['Yıllık izin', 'Günlük harcırah', 'Sigorta', 'Prim'], correct: 1 },
        { q: 'Low-cost havayoluna örnek?', options: ['Emirates', 'THY', 'Pegasus', 'Qatar'], correct: 2 }
      ]
    }
  },

  // ==================== ÜNİTE 5: MESLEĞİN ZORLUKLARI ====================
  'CM-M1-U5-L1': {
    lesson_id: 'CM-M1-U5-L1',
    title: 'Fiziksel Zorluklar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Memurluğunun Fiziksel Gereksinimleri',
      paragraphs: [
        'Uzun saatler ayakta: Bir uçuşta 10+ saat ayakta olabilirsiniz. Rahat ama profesyonel ayakkabılar şart.',
        'Ağır kaldırma: Üst kabin bagajları, servis arabaları, acil ekipmanlar. Düzenli egzersiz önemli.',
        'Kabin basıncı: Uçak kabini deniz seviyesinden yüksek basınçta tutulur. Bu yorgunluk ve dehidrasyon yapabilir.',
        'Jet lag ve uyku düzensizliği: Farklı zaman dilimleri vücudu zorlar. Uyku hijyeni kritik.',
        'Radyasyon: Yüksek irtifada kozmik radyasyona maruz kalma. Uzun vadede sağlık takibi gerektirir.'
      ],
      keyPoints: [
        'Fiziksel dayanıklılık gerektirir',
        'Düzenli egzersiz ve sağlıklı beslenme önemli',
        'Jet lag yönetimi öğrenilmeli',
        'Su tüketimi artırılmalı'
      ]
    }
  },

  'CM-M1-U5-L2': {
    lesson_id: 'CM-M1-U5-L2',
    title: 'Duygusal Zorluklar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Memurluğunun Duygusal Boyutu',
      paragraphs: [
        'Ailden ve arkadaşlardan uzak kalma: Özel günler, tatiller, hafta sonları çalışıyor olabilirsiniz.',
        'Zor yolcularla başa çıkma: Sinirli, sarhoş, talepkar veya saygısız yolcular. Sakin ve profesyonel kalmalısınız.',
        'Acil durumlar: Medikal aciller, türbülans, panik atak yaşayan yolcular. Stres altında soğukkanlılık gerektirir.',
        'Yalnızlık: Sürekli seyahat, geçici ilişkiler, "evde değilmiş" hissi. Sosyal destek ağı önemli.',
        'Duygusal emek: Her zaman gülümsemek, pozitif olmak zorunda hissetmek. Tükenmişlik riski var.'
      ],
      keyPoints: [
        'İş-yaşam dengesi zor olabilir',
        'Duygusal dayanıklılık geliştirin',
        'Destek sisteminizi koruyun',
        'Kendinize zaman ayırın'
      ]
    }
  },

  'CM-M1-U5-L3': {
    lesson_id: 'CM-M1-U5-L3',
    title: 'Senaryo: Zor Karar',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Mülakatta size soruyorlar:',
      question: '"En yakın arkadaşınızın düğünü var ama o gün çalışmanız gerekiyor. Ne yaparsınız?"',
      options: [
        { id: 'A', text: 'Hasta raporu alırım, arkadaşlık daha önemli.', isCorrect: false },
        { id: 'B', text: 'Kesinlikle işe giderim, arkadaşım anlar.', isCorrect: false },
        { id: 'C', text: 'Önceden program değişikliği talep ederim. Mümkün olmazsa, işime sadık kalır ve arkadaşıma durumu açıklarım.', isCorrect: true },
        { id: 'D', text: 'Bu mesleğin dezavantajı, her önemli günü kaçırırız.', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Önce proaktif çözüm (program değişikliği), sonra profesyonel sorumluluk. Bu olgun bir yaklaşım.',
        wrong: 'Bu cevap ya etik dışı (rapor) ya da aşırı katı ya da negatif. Dengeyi göstermelisiniz.'
      },
      explanation: 'Havayolları "work-life balance" zorluklarını biliyor. Önemli olan: 1) Proaktif planlama, 2) İşe bağlılık, 3) İletişim ve anlayış.'
    }
  },

  'CM-M1-U5-L4': {
    lesson_id: 'CM-M1-U5-L4',
    title: '🎮 Doğru mu Yanlış mı?',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Kabin memurları jet lag yaşamaz çünkü alışırlar.', isTrue: false, explanation: 'Yanlış! Jet lag her zaman bir zorluktur, sadece yönetmeyi öğrenirsiniz.' },
        { statement: 'Uzun uçuşlarda dehidrasyon riski artar.', isTrue: true, explanation: 'Doğru! Kabin havası kuru olduğundan su tüketimi çok önemli.' },
        { statement: 'Kabin memurları her özel günü kaçırır.', isTrue: false, explanation: 'Yanlış! Önceden planlama ile birçok etkinliğe katılabilirsiniz.' },
        { statement: 'Duygusal emek tükenmişliğe yol açabilir.', isTrue: true, explanation: 'Doğru! Sürekli pozitif görünme baskısı yorucu olabilir.' },
        { statement: 'Fiziksel egzersiz kabin memurları için gereksizdir.', isTrue: false, explanation: 'Kesinlikle yanlış! Fiziksel uygunluk bu meslekte kritik öneme sahiptir.' }
      ]
    }
  },

  // ==================== ÜNİTE 6: FİNAL ====================
  'CM-M1-U6-L1': {
    lesson_id: 'CM-M1-U6-L1',
    title: 'Genel Tekrar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Modül 1 Özeti: Kabin Memurluğuna Giriş',
      paragraphs: [
        'Bu modülde kabin memurluğunun gerçek yüzünü öğrendiniz.',
        'Mesleğin temeli GÜVENLİKtir. Servis ikincil bir görevdir. Mülakatta bu farkı göstermelisiniz.',
        'Çalışma düzeni: Show time, briefing, duty time, layover, reserve gibi kavramları öğrendiniz.',
        'Kariyer yolu: Junior → Senior → Purser → Yönetim. Her basamak yeni fırsatlar sunar.',
        'Zorluklar: Fiziksel (jet lag, uzun saatler) ve duygusal (aile uzaklığı, zor yolcular). Hazırlıklı olmalısınız.'
      ],
      keyPoints: [
        'Güvenlik = Birincil görev',
        'Çalışma düzeni esnek ama zorlayıcı',
        'Kariyer fırsatları mevcut',
        'Zorluklara hazırlıklı olun'
      ]
    }
  },

  'CM-M1-U6-L2': {
    lesson_id: 'CM-M1-U6-L2',
    title: '🎓 Modül 1 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'Kabin memurunun birincil görevi nedir?', options: ['Yemek servisi', 'Güvenlik', 'Duty-free satışı', 'Eğlence'], correct: 1 },
        { q: 'Show time ne demektir?', options: ['Gösteri zamanı', 'Uçuş sonu', 'Ekip toplantı saati', 'Mola zamanı'], correct: 2 },
        { q: 'Layover nedir?', options: ['Uçuş iptali', 'Varış noktasında kalış', 'Yedek görev', 'İzin günü'], correct: 1 },
        { q: 'Purser kimin liderlik ettiği pozisyondur?', options: ['Pilotlar', 'Yer ekibi', 'Kabin ekibi', 'Yolcular'], correct: 2 },
        { q: 'Duty time neyi ifade eder?', options: ['Dinlenme süresi', 'Yasal çalışma süresi', 'Layover süresi', 'Eğitim süresi'], correct: 1 },
        { q: 'Körfez havayollarına örnek:', options: ['Pegasus', 'THY', 'Emirates', 'Ryanair'], correct: 2 },
        { q: 'Jet lag nedir?', options: ['Uçak arızası', 'Zaman dilimi uyumsuzluğu', 'Türbülans', 'Bagaj kaybı'], correct: 1 },
        { q: 'Staff travel ne demektir?', options: ['Personel eğitimi', 'Çalışan uçuş bileti', 'Yönetici seyahati', 'İş gezisi'], correct: 1 },
        { q: 'Per diem neyi ifade eder?', options: ['Aylık maaş', 'Günlük harcırah', 'Yıllık prim', 'Sigorta'], correct: 1 },
        { q: 'Mülakatta "neden kabin memuru" sorusuna en iyi cevap:', options: ['Dünyayı gezmek için', 'İnsanlara hizmet ve güvenlik sağlamak için', 'İyi maaş için', 'Arkadaşım önerdi'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM1U3to6;
